var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-tip"},[_c('div',{staticClass:"line",style:({'background-color': _vm.bgColor})}),_c('div',{staticClass:"circle",style:({'background-color': _vm.bgColor})})])
}
var staticRenderFns = []

export { render, staticRenderFns }